import { render, staticRenderFns } from "./AddProductOrderModal.vue?vue&type=template&id=0979e430"
import script from "./AddProductOrderModal.vue?vue&type=script&lang=ts"
export * from "./AddProductOrderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0979e430')) {
      api.createRecord('0979e430', component.options)
    } else {
      api.reload('0979e430', component.options)
    }
    module.hot.accept("./AddProductOrderModal.vue?vue&type=template&id=0979e430", function () {
      api.rerender('0979e430', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/components/AddProductOrderModal.vue"
export default component.exports